import {useCallback} from 'react';
import {adminGetSecrets} from '../api/callable/adminGetSecrets';
import {useFunctionRun} from './helper/function/useFunctionRun';

export type Secret = {name: string; maskedValue: string};

export default function useSecrets(): {
  secrets: Secret[];
  loading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
} {
  const load = useCallback(() => adminGetSecrets({}), []);
  const {data, loading, error, refetch} = useFunctionRun(load);

  return {
    secrets: Array.isArray(data) ? (data as Secret[]) : [],
    loading,
    error: error ?? null,
    refetch,
  };
}
